/**
 * @file /study/:familyId/notes — 学びメモの面へ移す。
 *
 * @what: いちごスタディのタブ「学びメモ」(`/study/:familyId?view=notes`) へ、`?note=` などの指定を
 *   残したまま移す。
 * @why: 学びメモは本だななどと同じタブの1つになった (代表の判断、2026-10-29)。先に出した URL を
 *   開いても迷わないように残す。
 * @failure: 移すだけで、失敗しない。
 */

import { Navigate, useLocation, useParams } from "react-router-dom";

export function StudyNotesRoute() {
  const { familyId = "" } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("view", "notes");
  return <Navigate to={`/study/${encodeURIComponent(familyId)}?${params.toString()}`} replace />;
}
